import React from 'react';
import WithProcessError from 'hocs/WithProcessError';
import PropTypes from 'prop-types';

import FormGroup from 'components/FormGroup/FormGroup';
import FormItem from 'components/FormItem/FormItem';
import IconButton from 'components/IconButton/IconButton';
import Input from 'components/Input/Input';
import Panel from 'components/Panel/Panel';
import PanelHeader from 'components/PanelHeader/PanelHeader';
import Select from 'components/Select/Select';

import Check24 from 'icons/Check24';
import Close24 from 'icons/Close24';

import useApi from 'utils/api';
import { useAuth } from 'utils/auth';
import { rolesMap } from 'utils/permissions';
import { validateEmail } from 'utils/validate';

import styles from './settings.scss';

function AddMember(props) {
    const api = useApi();
    const auth = useAuth();

    const companyId = auth?.company.id;

    const { onCancel, processError, onUserAdded } = props;

    const [email, setEmail] = React.useState({ value: '', error: null });
    // const [name, setName] = React.useState({ value: '', error: null });
    const [role, setRole] = React.useState('30');

    const [loading, setLoading] = React.useState(false);

    // function handleNameChange(e) {
    //     const value = e.target.value;
    //     setName({ value, error: validateName(value) });
    // }

    function handleEmailChange(e) {
        const value = e.target.value;
        setEmail({ value, error: validateEmail(value) });
    }

    function validateFields() {
        const emailError = validateEmail(email.value);

        setEmail((email) => ({ ...email, error: emailError }));
        // setName(name => ({ ...name, error: nameError }));

        return emailError === null;
    }

    function handleRoleChange(value) {
        setRole(value);
    }

    function handleConfirm() {
        if (!validateFields()) return false;

        const userData = {
            name: name.value,
            email: email.value,
            role,
        };

        setLoading(true);

        api.addUserToCompany(companyId, userData)
            .then((result) => {
                console.log(result);

                if (typeof onUserAdded === 'function') {
                    onUserAdded();
                }
            })
            .catch((error) => {
                processError('Не удалось добавить участника', error);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    function getCurrentRoleId() {
        const currentRoleKey = auth.getRole();
        for (const role in rolesMap) {
            if (rolesMap[role].key === currentRoleKey) {
                return role;
            }
        }
    }

    function getRolesOptions() {
        const options = [];

        for (const roleId in rolesMap) {
            const userRole = getCurrentRoleId();

            // We can add users with lower role only
            if (Number(userRole) < Number(roleId)) {
                options.push({ value: roleId, label: rolesMap[roleId].label });
            }
        }

        return options;
    }

    return (
        <Panel
            separated={true}
            header={
                <PanelHeader
                    title={'Добавить участника'}
                    back={true}
                    onBackClick={onCancel}
                    after={
                        <IconButton
                            loading={loading}
                            onClick={handleConfirm}
                            icon={<Check24 />}
                            accent={true}
                        />
                    }
                    backIcon={<Close24 />}
                />
            }
        >
            <div className={styles.addMember}>
                <FormGroup>
                    <FormItem>
                        <p className={styles.note}>
                            Мы отправим приглашение в вашу компанию на Email
                            коллеги.
                        </p>
                    </FormItem>
                    <FormItem
                        label={'Email'}
                        required={true}
                        error={email.error}
                    >
                        <Input
                            type="text"
                            name="email"
                            placeholder={'email@example.com'}
                            value={email.value}
                            onChange={handleEmailChange}
                        />
                    </FormItem>
                    {/* <FormItem label={'Имя'} required={true} error={name.error}>
                        <Input
                            type="text"
                            name="name"
                            placeholder={'Асафьев Стас'}
                            value={name.value}
                            onChange={handleNameChange}
                        />
                    </FormItem> */}
                    <FormItem label={'Роль'} required={true}>
                        <Select
                            options={getRolesOptions()}
                            onChange={handleRoleChange}
                            defaultValue={role}
                        />
                    </FormItem>
                </FormGroup>
            </div>
        </Panel>
    );
}

AddMember.propTypes = {
    /**
     * Function to trigger on adding cancelled.
     */
    onCancel: PropTypes.func,
    onUserAdded: PropTypes.func,
    ...WithProcessError.propTypes,
};

export default WithProcessError(AddMember);
